import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Image,
  Input,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";

import { CheckIcon } from "@chakra-ui/icons";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import React, { useState } from "react";
import { MdUpload } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddAnswerData } from "redux/slices/addAnswerSlice";
import { selectAddCertificateData } from "redux/slices/addCertificateSlice";
import { getAddCourseData } from "redux/slices/AddCourseSlice";
import {
  getAddFormationData,
  setDescription,
  setImage,
  setLoading,
  setPrice,
  setTitle,
} from "redux/slices/addFormationSlice";
import { getAddQuestionData } from "redux/slices/AddQuestionSlice";
import { getAddRessourceData } from "redux/slices/addRessourceSlice";
import { getAddTestData } from "redux/slices/AddTestSlice";
import { getProfileData } from "redux/slices/userSlice";
import Dropzone from "views/admin/profile/components/Dropzone";
import CoursesModal from "./components/course/CoursesModal";
import TestModal from "./components/test/TestModal";

export default function Settings() {
  const [id, setId] = useState(0);
  const { title, description, image, price, loading, error } =
    useAppSelector(getAddFormationData);
  console.log({ title, description, image, price, loading, error });
  const dispatch = useAppDispatch();
  const profile = useAppSelector(getProfileData);
  const courses = useAppSelector(getAddCourseData).courses;
  const tests = useAppSelector(getAddTestData).tests;
  const questions = useAppSelector(getAddQuestionData).questions;
  const answers = useAppSelector(getAddAnswerData).answers;
  const certificate = useAppSelector(selectAddCertificateData);
  const fileUrl = useAppSelector(getAddRessourceData).fileUrl;
  const toast = useToast();
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  const [fileInputState, setFileInputState] = useState("");
  const [previewSource, setPreviewSource] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [disabled, setDisabled] = useState(false);
  const handleFileInputChange = React.useCallback((acceptedFiles: any) => {
    console.log("changing");
    /*const file = files.target.files[0];
        previewFile(file);
        setSelectedFile(file);
        setFileInputState(files.target.value);*/
    previewFile(acceptedFiles[0]);
    setSelectedFile(acceptedFiles[0]);
    setFileInputState(acceptedFiles[0]);
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const previewFile = (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const handleSubmitFile = () => {
    //e.preventDefault();
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => {
      uploadImage(selectedFile);
    };
    reader.onerror = () => {
      console.error("AHHHHHHHH!!");
      setErrMsg("something went wrong!");
    };
    setDisabled(true);
  };

  const uploadImage = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      for (var key of formData.entries()) {
        console.log(key[0] + ", " + new Object(key[1]));
      }

      const response = await axios.post(apiurl + "/file/upload", formData);
      console.log(response.data);
      dispatch(setImage(response.data));

      setFileInputState("");
      setPreviewSource("");
      setSuccessMsg("Image uploaded successfully");
    } catch (err) {
      console.error(err);
      setErrMsg("Something went wrong!");
    }
  };
  const addFormationSubmitHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${apiurl}/formation`, {
        courses: {
          createMany: {
            data: courses.map((course) => {
              return {
                title: course.title,
                description: course.description,
                image: course.image,
                ressource: course.ressource,
                ressourceType: course.ressourceType,
              };
            }),
          },
        },
        tests: {
          create: {
            title: tests[0].title,
            description: tests[0].description,
            questions: {
              create: questions
                .filter((question) => question.testId === tests[0].id)
                .map((question) => {
                  return {
                    content: question.content,
                    responseTimeout: question.responseTimeout,
                    questionType: {
                      create: {
                        value: "QCM",
                      },
                    },
                    answers: {
                      create: answers
                        .filter((answer) => answer.questionId === question.id)
                        .map((answer) => {
                          return {
                            content: answer.content,
                            isCorrect: answer.isCorrect,
                          };
                        }),
                    },
                  };
                }),
            },
          },
        },
        certificate: {
          create: {
            certificateModel: "",
            date: new Date(),
          },
        },
        title: title,
        description: description,
        stagiarePrice: parseFloat(price),
        professionalPrice: parseFloat(price) + 20,
        image,
      });
      console.log(res.data);
      dispatch(setLoading(false));
      toast({
        title: "Ajouté avec succés",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } catch (err) {
      toast({
        title: "Erreur d'ajout",
        description: error,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  };

  // Chakra Color Mode
  return (
    <form action="" onSubmit={addFormationSubmitHandler}>
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <SimpleGrid
          mb="20px"
          columns={{ sm: 1, md: 2 }}
          spacing={{ base: "20px", xl: "20px" }}
        >
          <FormControl id="email">
            <FormLabel>Nom de formation</FormLabel>
            <Input
              value={title}
              onChange={(e) => dispatch(setTitle(e.target.value))}
              borderRadius={"full"}
              type="text"
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel>Description</FormLabel>
            <Input
              value={description}
              onChange={(e) => dispatch(setDescription(e.target.value))}
              borderRadius={"full"}
              type="text"
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel>Prix (DT)</FormLabel>
            <Input
              value={price}
              onChange={(e) => dispatch(setPrice(e.target.value))}
              borderRadius={"full"}
              type="number"
            />
          </FormControl>

          <FormControl id="email">
            <FormLabel>Image</FormLabel>
            <Card mb="20px" alignItems="center" p="20px">
              <Flex h="100%" direction={{ base: "column", "2xl": "row" }}>
                <Dropzone
                  onDrop={handleFileInputChange}
                  w={{ base: "100%", "2xl": "268px" }}
                  me="36px"
                  maxH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                  minH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                  content={
                    <Box>
                      <Icon
                        as={MdUpload}
                        w="80px"
                        h="80px"
                        color={brandColor}
                      />
                      <Flex justify="center" mx="auto" mb="12px">
                        <Text fontSize="xl" fontWeight="700" color={brandColor}>
                          Choisir image
                        </Text>
                      </Flex>
                      <Text
                        fontSize="sm"
                        fontWeight="500"
                        color="secondaryGray.500"
                      >
                        PNG, JPG et GIF sont autorisés
                      </Text>
                    </Box>
                  }
                  value={fileInputState}
                />
                <Flex direction="column" pe="44px">
                  {previewSource ? (
                    <Image src={previewSource} />
                  ) : (
                    <>
                      <Text
                        color={textColorPrimary}
                        fontWeight="bold"
                        textAlign="start"
                        fontSize="2xl"
                        mt={{ base: "20px", "2xl": "50px" }}
                      >
                        Choisir une image comme thumbnail pour votre formation
                      </Text>
                      <Text
                        color={textColorSecondary}
                        fontSize="md"
                        my={{ base: "auto", "2xl": "10px" }}
                        mx="auto"
                        textAlign="start"
                      ></Text>
                    </>
                  )}
                  <Flex w="100%">
                    <Button
                      onClick={handleSubmitFile}
                      me="100%"
                      mb="50px"
                      w="140px"
                      minW="140px"
                      variant="brand"
                      mt={{ base: "20px", "2xl": "auto" }}
                      fontWeight="500"
                    >
                      Publier maintenant
                    </Button>
                  </Flex>
                </Flex>
              </Flex>
            </Card>
          </FormControl>
          <Stack my={5} direction="row" spacing={"auto"}>
            <CoursesModal formationsId={id} setFormationId={setId} />
            <TestModal formationId={id} />
            <Button
              leftIcon={<CheckIcon />}
              type="submit"
              colorScheme={"brand"}
            >
              Valider
            </Button>
          </Stack>
        </SimpleGrid>
      </Box>
    </form>
  );
}
